import { c as _c } from "react/compiler-runtime";
import { ArrowDown, Map, Target } from 'lucide-react';

/**
 * Intro for the consumer-journey section: two framing boxes (the journey and
 * the tactics) that set up the detailed framework blocks below.
 */
export function DemandJourneyIntroBlock() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col border-2 border-gray-950 bg-white p-6 shadow-[8px_8px_0_0_#211d4f] sm:p-8"><div className="flex items-center gap-2"><Map className="h-5 w-5 shrink-0 text-[#d63f20]" aria-hidden="true" /><p className="text-sm font-black uppercase tracking-[0.12em] text-[#d63f20]">The journey</p></div><p className="mt-4 text-2xl font-black leading-[1.05] tracking-[-0.02em] sm:text-3xl">Consumers go on a journey, from first knowing your product exists to becoming loyal, repeat customers.</p></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div><div className="grid gap-5 sm:grid-cols-2">{t0}<div className="flex flex-col border-2 border-gray-950 bg-[#211d4f] p-6 text-white shadow-[8px_8px_0_0_#ff5a36] sm:p-8"><div className="flex items-center gap-2"><Target className="h-5 w-5 shrink-0 text-[#ff7354]" aria-hidden="true" /><p className="text-sm font-black uppercase tracking-[0.12em] text-[#ff7354]">The tactics</p></div><p className="mt-4 text-2xl font-black leading-[1.05] tracking-[-0.02em] sm:text-3xl">Tactics are how you show up at each stage and become the product they choose, again and again.</p></div></div></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}